import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsProducts from '@atlassian/jira-navigation-apps-sidebar-global-settings-products/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { polarisSettingsViewBlueprintsRoute } from '@atlassian/jira-router-routes-polaris-routes/src/polarisSettingsViewBlueprintsRoute.tsx';
import { polarisProductViewBlueprintsSettingsPageEntryPoint } from './ui/settings/view-blueprints/index.tsx';

export const polarisSettingsViewBlueprintsRouteEntry = createEntry(
	polarisSettingsViewBlueprintsRoute,
	() => ({
		isStrictModeEnabled: false,
		group: 'global-settings',
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_PRODUCTS_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsProducts,
		},

		component: ErrorPagesNotFound,
		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],

		entryPoint() {
			return fg('jpd-view-templates-sample-project')
				? polarisProductViewBlueprintsSettingsPageEntryPoint
				: undefined;
		},

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-polaris-entries/src/polarisSettingsViewBlueprintsRouteEntry.tsx',
				whichExportToUse: 'polarisSettingsViewBlueprintsRouteEntry',
			},

			enabled: true,
		},
	}),
);
